import { API_HOST, } from "src/environments/environment";

export class Alert {
    source: string;
    detectionClass: string;
    validatedClass: string;
    before: string;
    after: string;
    validation: string;
    validationDate: string;
    detectionDate: string;
    embargo: string;
    assentamento: string;
    mapIdBefore: string;
    mapIdAfter: string;
    ti: string;
    car: string;
    area: string;
    uc: string;
    carApp: string;
    carRL: string;
    geoJson: string;
    biome: string;
    municipalities:string;
    alertId: number;
    alertGeometryId: number;
    afterImgUrl: string;
    beforeImgUrl: string;
    ancientVegetation: string;
    restrictedArea: string;
    asv: string;

    getArea() {
        return this.area.replace('.', ',').slice(0, 6);
    }

    getBeforeImgUrl(dataLayer: string) {
        return this.beforeImgUrl;
    }

    getAfterImgUrl(dataLayer: string) {
        return this.afterImgUrl;
    }
}
